var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoinMoneySignArrows = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M20 12h6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m26 10 3 2.003L26 14"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M28 19h-7"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m22 21-3-2.003L22 17"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m20 8.04-.84-1.373-1.684-.145-1.22-1.097-1.658.305-1.5-.73-1.5.73-1.659-.305-1.22 1.097-1.683.145-.84 1.374-1.572.583-.392 1.54-1.333.974.087 1.581L2 14.006l.559 1.494L2 16.994l.986 1.287-.087 1.58 1.333.975.392 1.54 1.572.583.84 1.374 1.684.145 1.22 1.097 1.658-.305 1.5.73 1.5-.73 1.659.305 1.22-1.097"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#00AED9",
  d: "M9.884 18.94c-.107-.105-.341-.527 0-1.118.341-.59.843-.453.97-.358.363.242 1.014.696 1.814.696.512 0 .886-.317.886-.76 0-.527-.47-.875-1.323-1.276-1.227-.602-2.475-1.277-2.475-2.797 0-1.255.992-2.522 2.955-2.522 1.334 0 2.358.676 2.742.95.15.084.053.675-.182.992s-.704.623-.96.475c-.288-.2-1.045-.686-1.728-.686-.533 0-.779.327-.779.696 0 .422.502.75 1.398 1.182 1.13.549 2.582 1.16 2.582 2.88 0 1.31-1.142 2.618-3.02 2.618-1.664.01-2.581-.676-2.88-.971"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1.518,
  height: 3.039,
  x: 11.99,
  y: 9.286,
  fill: "#00AED9",
  rx: 0.759
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1.518,
  height: 3.039,
  x: 11.99,
  y: 18.402,
  fill: "#00AED9",
  rx: 0.759
})));
export default SvgCoinMoneySignArrows;